import React from "react";
import JourneyBlock from "../List/JourneyBlock";
/*import TreatmentTable from "../Treatments/List/TreatmentTable";
import InfantActivityTable from "../MotherInfantJourney/Activities/List/InfantActivityTable";
import ChildBlock from "../MotherInfantJourney/Child/ChildBlock";
import ChildHistoryBlock from "../PatientAdditionalInfo/ChildHistoryBlock";
import AssessBFTable from "../MotherInfantJourney/Activities/List/AssessBFTable";
import MedicalFacilityBlock from "../../Organizations/MedicalCareFacility/MedicalFacilityBlock";
import WellnessBlock from "../Wellness/List/WellnessBlock";
import DailyMeasurementTable from "../DailyMeasurements/List/DailyMeasurementTable";
import FamilyMemberList from "../../Organizations/Members/FamilyMemberList";
import GenericActivityTable from "../Health/Activities/List/GenericActivityTable";
import PatientAdditionalInfoView from "../PatientAdditionalInfo/PatientAdditionalInfoView";
import OrgMemberBlock from "../../Organizations/Members/OrgMemberBlock";*/
import ActivityList from "../Activities/ActivityList";

const Components = (props) => {
  let components = {
    journey_profile: JourneyBlock,
    /*cancer_journey : {
      journey_profile: JourneyBlock,
      symptoms:WellnessBlock,
      daily_check:DailyMeasurementTable,
      pain_tracking:WellnessBlock,
      side_effects:WellnessBlock,
      care_giver:FamilyMemberList,
      health_center:MedicalFacilityBlock,
      family_member:FamilyMemberList
    }*/
  }

  let TagName = components[props.componentName];  

  if(TagName){
  	return <TagName {...props}/>
  }else if(props.defaultViewType === "activityTable"){
  	return <ActivityList {...props}/>
  }

  return null;
  
}

export default Components